import { CollectionListStatus } from '@/types'

export interface SearchCollectionListRequest {
  name: string
  status: CollectionListStatus
}

export function SearchCollectionListRequestToJSON(
  value: SearchCollectionListRequest
): any {
  return {
    name: value.name !== '' ? value.name : undefined,
    status: value.status ?? undefined
  }
}
